import { Component } from '@angular/core';
import { FooterComponent } from '@shared/components/footer/footer.component';
import { HeaderComponent } from '@shared/components/header/header.component';
import { RetrieveUsernameComponent } from '@shared/components/retrieve-username/retrieve-username.component';

@Component({
  selector: 'app-forgot-username',
  templateUrl: './forgot-username.component.html',
  styleUrls: ['./forgot-username.component.scss'],
  imports: [FooterComponent, RetrieveUsernameComponent, HeaderComponent]
})
export class ForgotUsernameComponent {

  constructor() { }


}
